const LIBRE_BASKERVILLE_HREF = "/fonts/libre-baskerville.css";

let loaded = false;

/** Heading font (h4 / h6). Skipped on login/register — load after sign-in. */
export function loadLibreBaskerville(): void {
  if (loaded || typeof document === "undefined") return;
  if (document.querySelector(`link[href="${LIBRE_BASKERVILLE_HREF}"]`)) {
    loaded = true;
    return;
  }
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = LIBRE_BASKERVILLE_HREF;
  document.head.appendChild(link);
  loaded = true;
}
